var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9228 10.2C16.5088 10.2 16.1728 9.86401 16.1728 9.45001V7.30301C16.1728 5.20701 14.4678 3.50201 12.3718 3.50201H12.3558C11.3428 3.50201 10.3938 3.89201 9.67676 4.60301C8.95476 5.31701 8.55576 6.27001 8.55176 7.28601V9.45001C8.55176 9.86401 8.21576 10.2 7.80176 10.2C7.38776 10.2 7.05176 9.86401 7.05176 9.45001V7.30301C7.05776 5.86301 7.61476 4.53401 8.61976 3.53801C9.62576 2.54101 10.9538 1.96401 12.3748 2.00201C15.2948 2.00201 17.6728 4.38001 17.6728 7.30301V9.45001C17.6728 9.86401 17.3368 10.2 16.9228 10.2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.542 10.1289C6.864 10.1289 5.5 11.4929 5.5 13.1709V17.4599C5.5 19.1379 6.864 20.5019 8.542 20.5019H16.183C17.86 20.5019 19.225 19.1379 19.225 17.4599V13.1709C19.225 11.4929 17.86 10.1289 16.183 10.1289H8.542ZM16.183 22.0019H8.542C6.037 22.0019 4 19.9649 4 17.4599V13.1709C4 10.6659 6.037 8.62891 8.542 8.62891H16.183C18.688 8.62891 20.725 10.6659 20.725 13.1709V17.4599C20.725 19.9649 18.688 22.0019 16.183 22.0019Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3623 17.1756C11.9483 17.1756 11.6123 16.8396 11.6123 16.4256V14.2046C11.6123 13.7906 11.9483 13.4546 12.3623 13.4546C12.7763 13.4546 13.1123 13.7906 13.1123 14.2046V16.4256C13.1123 16.8396 12.7763 17.1756 12.3623 17.1756Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.0ae423e225a2ba600ac4deb71daf7039.svg";
export { ForwardRef as ReactComponent };